import * as THREE from 'three';
import { BaseEnemy } from './base.js';
import { ENEMY_STATS } from '../../data/enemies.data.js';

export class Drone extends BaseEnemy {
  constructor(opts) {
    super({ ...opts, stats: ENEMY_STATS.drone });
  }

  updateAI(dt, game) {
    const player = game.player;
    if (!player.alive) return;
    const d = this.distTo(player.x, player.z);
    this.sensePlayer(game, dt);

    const targetX = player.x;
    const targetZ = player.z;
    this.aimX = (targetX - this.x);
    this.aimZ = (targetZ - this.z);
    const aimLen = Math.hypot(this.aimX, this.aimZ) || 1;
    this.aimX /= aimLen; this.aimZ /= aimLen;

    if (!this._lastCanSeePlayer || d > this.stats.attackRange * 0.9) {
      this.state = 'chase';
      this.moveWithPathfinding(targetX, targetZ, dt, game, 1);
    } else {
      this.state = 'attack';
      if (this.fireCd <= 0) {
        game.spawnEnemyProjectile(
          this.x + this.aimX * 0.6,
          this.z + this.aimZ * 0.6,
          this.aimX,
          this.aimZ,
          { speed: this.stats.projectileSpeed, damage: this.stats.projectileDamage, life: 1.4 }
        );
        this.playFireRecoilAnim();
        this.fireCd = this.stats.fireCooldown;
      }
    }
  }
}
